import Rails from "@rails/ujs"

import "../packs/auth.scss"

Rails.start();
